import React from 'react';
import { Card } from 'antd';
import { FileTextOutlined, CalendarOutlined } from '@ant-design/icons';
import { formatDateTime } from '../../../../utils/functions';

const EnhancedActivityLogCardView = ({ record, onCardClick }) => {
    return (
        <Card
            hoverable
            className="h-full relative shadow-sm hover:shadow-md transition-shadow"
            onClick={() => onCardClick && onCardClick(record)}
            bodyStyle={{ padding: '16px' }}
        >
            <div className="flex flex-col gap-3">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-1">
                        <FileTextOutlined className="text-primary text-xl" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <h4 className="text-base font-semibold text-gray-800 mb-1 line-clamp-2">
                            {record.description || "No Description"}
                        </h4>
                        <div className="flex items-center text-gray-500 text-sm">
                            <CalendarOutlined className="mr-2" />
                            <span>{formatDateTime(record.dateAsPerUserTimezone)}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedActivityLogCardView;
